/*
 * <bedrock-menu-sidebar> — pane switching for the sidebar mega panel.
 *
 * The server renders the first pane visible and the rest [hidden], so the
 * scriptless page is already correct; this element only SWAPS which pane is
 * visible. Two triggers, one rule:
 *
 *   pointerenter — hover moves the highlight, no delay: inside an
 *     already-open panel there is no drag-across problem for an intent
 *     timer to solve, and the reference switches instantly.
 *   focusin — a keyboard user tabbing onto a trigger sees the same pane a
 *     hover would show; hidden panes are out of the tab order by [hidden],
 *     so Tab walks trigger → its pane's tiles, never through a ghost pane.
 *
 * Clicks are left alone entirely: a trigger is a real link and it NAVIGATES.
 */

if (!customElements.get('bedrock-menu-sidebar')) {
  customElements.define(
    'bedrock-menu-sidebar',
    class BedrockMenuSidebar extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('.menu-sidebar__trigger'));
        this.triggers.forEach((trigger) => {
          const activate = () => this.activate(trigger);
          trigger.addEventListener('pointerenter', activate);
          trigger.addEventListener('focusin', activate);
        });
      }

      activate(trigger) {
        if (trigger.classList.contains('is-visible')) return;
        this.triggers.forEach((other) => other.classList.toggle('is-visible', other === trigger));
        this.querySelectorAll('.menu-sidebar__pane').forEach((pane) => {
          pane.hidden = pane.id !== trigger.dataset.pane;
        });
      }
    }
  );
}
